import ApiCaller from 'actions/ApiCaller';
import baseConfig from 'actions/BaseAjaxConfig';
export var issueFaqActionsEnum;
(function (issueFaqActionsEnum) {
    issueFaqActionsEnum["ISSUEFAQ_REQUEST"] = "ISSUEFAQ_REQUEST";
    issueFaqActionsEnum["ISSUEFAQ_SUCCESS"] = "ISSUEFAQ_SUCCESS";
    issueFaqActionsEnum["ISSUEFAQ_ERROR"] = "ISSUEFAQ_ERROR";
    issueFaqActionsEnum["SELECT_ISSUEFAQ"] = "SELECT_ISSUEFAQ";
    issueFaqActionsEnum["SELECT_PARENT_ISSUEFAQ"] = "SELECT_PARENT_ISSUEFAQ";
    issueFaqActionsEnum["STATIC_ISSUE_REQUEST"] = "STATIC_ISSUE_REQUEST";
    issueFaqActionsEnum["STATIC_ISSUE_SUCCESS"] = "STATIC_ISSUE_SUCCESS";
    issueFaqActionsEnum["STATIC_ISSUE_ERROR"] = "STATIC_ISSUE_ERROR";
})(issueFaqActionsEnum || (issueFaqActionsEnum = {}));
export function fetchIssueFaq(id) {
    return (dispatch) => {
        dispatch({
            type: issueFaqActionsEnum.ISSUEFAQ_REQUEST
        });
        const pathname = '/api/1/self-serve/helpcenter/staticFaq/';
        return ApiCaller.get(Object.assign({}, baseConfig, {
            pathname,
            action: issueFaqActionsEnum.ISSUEFAQ_REQUEST,
            query: { subIssueId: id }
        })).then(data => {
            dispatch({ type: issueFaqActionsEnum.ISSUEFAQ_SUCCESS, data: data.RESPONSE });
        }, error => {
            dispatch({ type: issueFaqActionsEnum.ISSUEFAQ_ERROR, error });
        });
    };
}
export function fetchIssues() {
    return (dispatch) => {
        dispatch({
            type: issueFaqActionsEnum.STATIC_ISSUE_REQUEST
        });
        const pathname = `/api/1/self-serve/helpcenter/issues`;
        return ApiCaller.get(Object.assign({}, baseConfig, { pathname, action: issueFaqActionsEnum.STATIC_ISSUE_REQUEST })).then(data => {
            dispatch({
                type: issueFaqActionsEnum.STATIC_ISSUE_SUCCESS,
                data: data.RESPONSE
            });
        }, error => {
            dispatch({ type: issueFaqActionsEnum.STATIC_ISSUE_ERROR, error });
        });
    };
}
export function setSelectedIssueFaq(index) {
    return { type: issueFaqActionsEnum.SELECT_ISSUEFAQ, selectedIssueIndex: index };
}
export function setParentIssueFaq(issue) {
    return { type: issueFaqActionsEnum.SELECT_PARENT_ISSUEFAQ, parentIssue: issue };
}
